import {MilestoneTypes} from "./constants";

export function meetsMilestoneValidationRequirements(milestones = []) {
    const deliverySteps = milestones.filter(m => m.type === 5);
    const initiativeSteps = milestones.filter(m => m.type === 0);
    const stakeholderMilestonesTypes = MilestoneTypes.map(function(item){
        return (item.label === "Stakeholder Review" ? item.value : null)
    }).filter(n => n !== null)
    const stakeholderMilestones = milestones.filter(item => stakeholderMilestonesTypes.indexOf(item.type) !== -1 );
    return deliverySteps.length >= 1 && initiativeSteps.length >= 2 && stakeholderMilestones.length === 9;
}